var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.666 109V222.583L205.333 161.25L193.583 173L253.833 233.333H47.166L105.499 173L93.4994 161.417L33.3327 223.667V79.3333L136.916 182.417C140.039 185.521 144.263 187.263 148.666 187.263C153.069 187.263 157.293 185.521 160.416 182.417L233.999 109.25C228.127 107.717 222.512 105.331 217.333 102.167L148.499 170.583L44.2493 66.6667H190.083C188.471 61.2536 187.602 55.6468 187.499 50H33.3327C28.9124 50 24.6732 51.7559 21.5476 54.8816C18.422 58.0072 16.666 62.2464 16.666 66.6667V233.333C16.666 237.754 18.422 241.993 21.5476 245.118C24.6732 248.244 28.9124 250 33.3327 250H266.666C271.086 250 275.326 248.244 278.451 245.118C281.577 241.993 283.333 237.754 283.333 233.333V101.667C278.168 104.917 272.552 107.388 266.666 109Z",
    fill: "#7985FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.001 90.4998C273.013 90.4998 291.667 71.845 291.667 48.8332C291.667 25.8213 273.013 7.1665 250.001 7.1665C226.989 7.1665 208.334 25.8213 208.334 48.8332C208.334 71.845 226.989 90.4998 250.001 90.4998Z",
    fill: "#7985FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.dfc0bd90.svg";
export { ForwardRef as ReactComponent };